export default __webpack_public_path__ + "static/media/Saravana.978dc788.png";